module.exports = __webpack_public_path__ + "img/promo-13seater01.75cfda23.jpg";